import {runtimeConfig} from '../../../../next.config.env.runtime';

const {internalConfig, publicConfig} = runtimeConfig;

/**
 * RunTimeConfigKeys
 * Type representing valid runtime configuration keys.
 * This is an intersection of keys from both internal and public config,
 * ensuring the key exists in both configs since getRuntimeConfig() may
 * access either depending on execution context (server vs client).
 */
export type RunTimeConfigKeys = keyof typeof internalConfig & keyof typeof publicConfig;

/**
 * getRuntimeConfig()
 * This method is used to supplement Next.js buildtime configurations with a method of resolving configuration at runtime.
 * @param name {string} The name of the configuration key to resolve.
 * @returns
 */
export const getRuntimeConfig = (name: RunTimeConfigKeys): string => {
    const IS_CI = process.env.IS_CI;
    let resolved;
    if (IS_CI) {
        // If we are in a CI environment, use the public context configuration
        resolved = publicConfig[name as keyof typeof publicConfig];
    } else {
        // Otherwise, if server, use internal context configuration,
        // if client, use public context configuration
        resolved =
            typeof window !== 'undefined'
                ? window.PUBLIC_CONFIG[name]
                : internalConfig[name as keyof typeof internalConfig];
    }
    // TODO: implement debug log mode
    // console.debug(`getRuntimeConfig: ${name} = ${resolved}`);
    return resolved;
};

/**
 *  getPublicConfig()
 *  Returns the public config
 */
export const getPublicConfig = (name: RunTimeConfigKeys): string => {
    return window.PUBLIC_CONFIG[name];
};
